<template>
    <div
        class="header"
        id="header"
    >
        <div class="nav-list">
            <img
                src="@/assets/home/nav_logo.png"
                alt=""
            >
            <div class="menu-list">
                <div class="menu-item">
                    <span
                        :class="{'active': item == activeMenu}"
                        @click="switchPageRouterHandle(item)"
                        v-for="(item,index) in headerMenuList"
                        :key="index"
                    >
                        {{ item }}
                    </span>
                </div>
                <!-- <div class="menu-line"></div> -->
                <div class="login-info">
                    <!-- <span @click="registerHandle">注册</span> -->
                    <!-- <span>登录</span> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { navFixed } from "../common/flexible";
export default {
    name: "Header",
    data() {
        return {
            headerMenuList: ["首页", "资源服务", "智能应用"],
            activeMenu: "首页",
        };
    },
    components: {},
    computed: {},
    methods: {
        switchPageRouterHandle(name) {
            let routerList = {
                首页: "/home",
                资源服务: "/source",
            };
            if (!routerList[name]) {
                this.$notify.info({
                    title: "Cozy Tips",
                    message: "该页面正在努力的开发中...",
                });
            } else {
                this.$router.push(routerList[name]);
            }
            this.activeMenu = name;
        },
        registerHandle() {
            this.$notify.info({
                    title: "Cozy Tips",
                    message: "暂未开放注册",
                });
        },
        swtichActiveMenu() {
            let activeList = {
                "/home": "首页",
                "/source": "资源服务",
                "/service": "资源服务",
                "/detail": "资源服务",
            };
            let routerPath = this.$route.path;
            this.activeMenu = activeList[routerPath];
        },
    },
    mounted() {
        this.swtichActiveMenu();
        window.addEventListener("scroll", navFixed);
    },
    watch: {
        $route(to, from) {
            this.swtichActiveMenu();
        },
    },
};
</script>
<style scoped>
.nav-list {
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    z-index: 5;
    width: 1200px;
    margin: auto;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
}
.nav-list img {
    width: 136px;
    height: 40px;
    display: block;
}
.menu-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.menu-item {
    display: flex;
    justify-content: space-between;
    width: 270px;
}
.menu-item span {
    box-sizing: border-box;
    display: inline-block;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.menu-item span.active {
    border-bottom: 2px solid #fff;
}
.menu-line {
    width: 2px;
    height: 20px;
    background: #ffffff;
    opacity: 0.65;
    margin-left: 32px;
}
.login-info {
    margin-left: 31px;
}
.login-info span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #fff;
    cursor: pointer;
}
.login-info span:nth-of-type(1) {
    display: inline-block;
    width: 68px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #27b3b1;
    border-radius: 14px;
}
.login-info span:nth-of-type(2) {
    margin-left: 30px;
}
</style>